/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../../inc/LayoutFooter";
import LayoutHeader from "../../inc/LayoutHeader";
import { RollbackOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { displayMessage, postAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import {
  UPDATE_LAUNDRY_ITEM,
  LAUNDRY_ITEM_BY_ID,
} from "../../../constants/api";

function ItemUpdate() {
  const { Content } = Layout;
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    postAPI(
      LAUNDRY_ITEM_BY_ID,
      { id },
      (data) => {
        if (data.status === true) {
          form.setFieldsValue(data.data);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch item");
      }
    );
  }, []);

  const updateData = (values) => {
    setLoading(true);
    postAPI(
      UPDATE_LAUNDRY_ITEM,
      { id, ...values },
      (data) => {
        if (data.status === true) {
          navigate("/laundry/item");
          displayMessage(SUCCESS_MESSAGE, data.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to update item");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Update Laundry Item"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={updateData}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    name="item_code"
                    label="Item Code"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="name"
                    label="Item Name"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="unit_rate"
                    label="Unit Rate"
                    rules={[{ required: true }]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item style={{ float: "right" }}>
                <Button loading={loading} htmlType="submit" type="primary">
                  Update
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default ItemUpdate;
